import { TierProFilled } from '@heidi/design-system/icons';
import { FormattedMessage } from 'react-intl';

import { getCommerceBillingUiPorts } from '../../settings/billing/billing-ui-ports';
import { TrialEndUsageClass } from './classify-trial-end-usage';
import { ComplimentaryTrialEndDialog } from './complimentary-trial-end-dialog';
import { complimentaryTrialEndedModalMessages as messages } from './complimentary-trial-ended-modal.messages';

export type ComplimentaryTrialEndedModalProps = {
  open: boolean;
  usageClass: TrialEndUsageClass.High | TrialEndUsageClass.Moderate;
  currentPlanName: string;
  targetPlanName: string;
  onUpgrade: () => void;
  onStay: () => void;
  onDismiss: () => void;
};

/**
 * Shown once a member's complimentary Max usage ends, recommending an upgrade
 * sized to how much of their plan allowance they used. Presentational: the
 * host owns the queue, analytics and where the upgrade goes.
 */
export const ComplimentaryTrialEndedModal = ({
  open,
  usageClass,
  currentPlanName,
  targetPlanName,
  onUpgrade,
  onStay,
  onDismiss,
}: ComplimentaryTrialEndedModalProps) => {
  if (getCommerceBillingUiPorts().isAppleCompliantBuild()) return null;

  return (
    <ComplimentaryTrialEndDialog
      open={open}
      onDismiss={onDismiss}
      testId="complimentary-trial-ended-modal"
      icon={<TierProFilled />}
      title={<FormattedMessage {...messages.title} />}
      description={
        <FormattedMessage
          {...(usageClass === TrialEndUsageClass.High
            ? messages.bodyHigh
            : messages.bodyModerate)}
          values={{ currentPlanName, targetPlanName }}
        />
      }
      primaryAction={{
        label: <FormattedMessage {...messages.upgrade} values={{ targetPlanName }} />,
        onClick: onUpgrade,
        testId: 'complimentary-trial-ended-modal-upgrade',
      }}
      secondaryAction={{
        label: <FormattedMessage {...messages.stay} values={{ currentPlanName }} />,
        onClick: onStay,
        testId: 'complimentary-trial-ended-modal-stay',
      }}
      footnote={<FormattedMessage {...messages.footnote} values={{ currentPlanName }} />}
    />
  );
};
